module.exports = __webpack_public_path__ + "img/PromoliderAulaW.bd83009e.webp";